<procure-expansion-panel
  class="filter-grid-panel"
  icon="filter_alt"
  flat
  [label]="label()"
  [badge]="activeFilters()"
  [loading]="loading()"
  [expanded]="defaultExpanded()"
  (opened)="opened.emit()"
>
  <div
    class="filter-grid"
    [class.collapsed]="!expanded() && !showAll()"
  >
    <div formRow>
      <div class="filters">
        <ng-content />
        @if (filterButtons().length > 8 && !vertical() && !showAll()) {
          <button
            procure-button
            variant="stroked"
            (click)="toggleExpansion()"
          >
            {{ expanded() ? "Fewer" : "More" }} Filters
          </button>
        }
      </div>
    </div>
    <div formRow>
      <button
        class="reset"
        procure-button
        variant="stroked"
        [class.vertical]="vertical()"
        (click)="resetFilters.emit()"
      >
        Reset Filters
      </button>
    </div>
  </div>
</procure-expansion-panel>
